import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const feedCardDefaultVariants = {}
const feedCardCompoundVariants = []

const feedCardSlotNames = [
  [
    "card",
    "feed-card__card"
  ],
  [
    "feedPhotoTreatment",
    "feed-card__feedPhotoTreatment"
  ],
  [
    "feedPhotoImage",
    "feed-card__feedPhotoImage"
  ],
  [
    "feedPhotoFallback",
    "feed-card__feedPhotoFallback"
  ],
  [
    "gradient",
    "feed-card__gradient"
  ],
  [
    "contentGrid",
    "feed-card__contentGrid"
  ],
  [
    "contentGridWithIndicators",
    "feed-card__contentGridWithIndicators"
  ],
  [
    "detailsArea",
    "feed-card__detailsArea"
  ],
  [
    "actionsArea",
    "feed-card__actionsArea"
  ],
  [
    "actionItem",
    "feed-card__actionItem"
  ]
]
const feedCardSlotFns = /* @__PURE__ */ feedCardSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, feedCardDefaultVariants, getSlotCompoundVariant(feedCardCompoundVariants, slotName))])

const feedCardFn = memo((props = {}) => {
  return Object.fromEntries(feedCardSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const feedCardVariantKeys = []
const getVariantProps = (variants) => ({ ...feedCardDefaultVariants, ...compact(variants) })

export const feedCard = /* @__PURE__ */ Object.assign(feedCardFn, {
  __recipe__: false,
  __name__: 'feedCard',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: feedCardVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, feedCardVariantKeys)
  },
  getVariantProps
})